import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-res-rds",
  "use": "oc-res-rds-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"oc-res-rds\"><path d=\"M729.6 140.8L512 6.4 294.4 140.8v262.4L512 537.6l224-134.4V140.8z m-57.6 224l-160 96-160-96V179.2l160-96 160 96v185.6z m-633.6 256v262.4L256 1017.6l217.6-134.4V620.8L256 486.4 38.4 620.8zM416 659.2v185.6l-160 96-160-96V659.2l160-96 160 96z m345.6-172.8L544 620.8v262.4l224 134.4 217.6-134.4V620.8l-224-134.4z m160 352l-153.6 96-160-89.6V665.6l160-96 153.6 89.6v179.2z\" p-id=\"1200\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol